export const formValidationConstants = {
  USER: {
    NAME: "User name is required.",
    EMAIL: "User email is required.",
    SCOPE: "Scope is required.",
  },
};
